import _extends from "@babel/runtime-corejs3/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { InputField } from '@unite-us/ui';
import { noop } from 'lodash';
import './stylesheets/phoneNumberField.scss';
var PhoneNumberField = function PhoneNumberField(props) {
  return /*#__PURE__*/React.createElement(InputField, _extends({
    className: "phone-number-field"
  }, props));
};
PhoneNumberField.propTypes = {
  hideLabel: PropTypes.bool,
  inline: PropTypes.bool,
  label: PropTypes.string,
  mask: PropTypes.string,
  placeholder: PropTypes.string,
  registerField: PropTypes.func,
  validations: PropTypes.oneOfType([PropTypes.array, PropTypes.func])
};
PhoneNumberField.defaultProps = {
  hideLabel: true,
  inline: false,
  label: 'Phone Number',
  mask: '(999) 999-9999 x 99999',
  placeholder: '(999) 999-9999',
  registerField: noop
  // validations: validations.isPhoneNumber,
};
export default PhoneNumberField;
//# sourceMappingURL=index.js.map